module.exports = __webpack_public_path__ + "static/media/windowsIcon.a25e19b2.svg";